<template>
  <div class="response-block__container">
    <div class="column">
      <div>Mapped URL
        (<span
          :class="{[getStatusCodeColor(state_initial_response_code)]: getStatusCodeColor(state_initial_response_code)}"
        >{{ initialCodeNum }}</span>{{ initialCodeText }})
      </div>
      <a class="response-block__link" target="_blank" :href="state_initial_response_url">{{ state_initial_response_url }}</a>
    </div>
    <div class="column" v-if="state_initial_response_code_published">
      <div>Published URL
        (<span
          :class="{[getStatusCodeColor(state_initial_response_code_published)]: getStatusCodeColor(state_initial_response_code_published)}"
        >{{ publishedCodeNum }}</span>{{ publishedCodeText }})
      </div>
      <a class="response-block__link" target="_blank" :href="state_initial_response_url_published ">{{ state_initial_response_url_published }}</a>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */

import status from 'statuses'

export default {
  name: 'ResponseCodeBlock',
  created () {
  },
  props: {
    state_initial_response_code: {
      type: String,
      required: true
    },
    state_initial_response_url: {
      type: String,
      required: true
    },
    state_initial_response_code_published: {
      type: String,
      required: false
    },
    state_initial_response_url_published: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      enabledColumns: []
    }
  },
  watch: {
    cbVersionId () {
      this.getKissScore()
    }
  },
  computed: {
    initialCodeNum () {
      return this.state_initial_response_code.split(' ')[0]
    },
    publishedCodeNum () {
      return this.state_initial_response_code_published && this.state_initial_response_code_published.split(' ')[0]
    },
    initialCodeText () {
      // return status(this.state_initial_response_code)
      try {
        return ' - ' + status(this.state_initial_response_code)
      } catch (e) {
        return ''
      }
    },
    publishedCodeText () {
      try {
        return ' - ' + status(this.state_initial_response_code_published)
      } catch (e) {
        return ''
      }
    }
  },
  methods: {
    getStatusCodeColor (code) {
      code = +code[0]
      let color = ''
      switch (code) {
        case 1:
          color = 'code-1x'
          break
        case 2:
          color = 'code-2x'
          break
        case 3:
          color = 'code-3x'
          break
        case 4:
          color = 'code-4x'
          break
        case 5:
          color = 'code-5x'
          break
        default:
          color = null
      }
      return color
    }
  }
}
</script>

<style scoped lang="scss">
.response-block__container {
      background-color: #fff;
      border-radius: $rfx-default-border-radius;
      border: 1px solid rgba(1, 22, 39, 0.1);
      display: flex;
      gap: 100px;
      width: 100%;
      align-items: center;
      height: 70px;
      padding-left: 24px;
}

.response-block__link {
  line-height: 30px;
}

.code-1x {
          color: $rfx-blue
}
.code-2x {
          color: $rfx-green
}
.code-3x {
          color: $rfx-orange
}
.code-4x {
          color: $rfx-purple
}
.code-5x {
          color: $rfx-red
}
</style>
